<footer>
    <p  class="text-xs-center">© Copyright 2019. All rights reserved.</p>
  </footer>